module.exports = __webpack_public_path__ + "img/consult_txt.3521e0fb.png";